import { COMMAND_DECK_LIVE_BANNER } from '../config/commandDeckMvp'

export function CommandDeckLiveBanner() {
  return (
    <div className="command-deck-banner command-deck-banner--live" role="status">
      {COMMAND_DECK_LIVE_BANNER}
    </div>
  )
}
